import type { RouteObject } from "react-router-dom";
import PropostaMvpPage from "../pages/proposta-mvp/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <PropostaMvpPage />,
  },
  {
    path: "*",
    element: <PropostaMvpPage />,
  },
];

export default routes;
